import React, { FC, useEffect, useMemo, useState } from "react"
import { observer } from "mobx-react-lite"
import { Appearance, ImageStyle, View, ViewStyle } from "react-native"
import { AutoImage, ModelCreateScreen, ProfileForm } from "../../../components"
import { CompositeScreenProps } from "@react-navigation/native"
import { useStores } from "../../../models"
import { color } from "../../../theme"
import config from "../../../utils/config"
import SyncableModel from "../../../database/SyncableModel"
import { User as Model } from "../../../database"
import JalaAnalytic from "../../../utils/jala-analytic"

const IMAGE_CONTAINER: ViewStyle = {
  alignItems: 'center',
  justifyContent: 'center',
  marginTop: 20
}

const IMG_WRAPPER: ViewStyle = {
  borderRadius: 70,
  borderWidth: 3,
  padding: 1,
  borderColor: color.palette.gray200,
  marginBottom: 18
}

const IMG: ImageStyle = {
  width: 84,
  height: 84,
  borderRadius: 60,
}

export const EditProfileScreen: FC<{ colorScheme?: "light" | "dark" } & CompositeScreenProps<any, any>> = observer(function EditProfileScreen(props) {
  const { colorScheme = "light" || Appearance.getColorScheme() } = props;

  const [ avatar, setAvatar ] = useState<any>(null);
  const [ model, setModel ] = useState<SyncableModel>(null);

  // Pull in one of our MST stores
  const { userStore: modelStore, userStore: { user, responseImage } } = useStores();

  const initialValues = useMemo(() => {
    const data = (model ? model.toArray() : user)
    return { ...data }
  },[model, user])

  const { BASE_URL } = config();

  useEffect(() => {
    modelStore.init()
    setAvatar({ uri: `${BASE_URL}/img/cache/medium/${user.avatar}` });
  },[BASE_URL, modelStore, user.avatar])

  useEffect(() => {
    const model = new Model();
    const attributes = { ...user }
      Object.keys(attributes).forEach((k) => {
        model.setAttribute(k, attributes[k])
      })
    model.syncOriginal();
    model.exists = true
    setModel(model)
  },[user, setModel])

  useEffect(() => {
    JalaAnalytic.log('Mobile app: account - edit')
  }, [])

  useEffect(() => {
    if (responseImage) setAvatar({ uri: responseImage.assets[0].uri });
    else setAvatar({ uri: `${BASE_URL}/img/cache/medium/${user.avatar}` });
  }, [BASE_URL, responseImage, user.avatar])

  return (
    <ModelCreateScreen
      colorScheme={colorScheme}
      ModelForm={ProfileForm}
      initialValues={initialValues}
      modelStore={modelStore}
      model={model}
      denyDelete
      HeaderComponent={<View style={IMAGE_CONTAINER}>
        { avatar && <View style={IMG_WRAPPER}><AutoImage source={avatar} style={IMG} /></View> }
      </View>}
    />
  )
})
